import React, { Component } from 'react';
import { FormGroup, Panel, FormControl, Col, ControlLabel} from 'react-bootstrap';
export default class WhereToSearch extends Component {

    render() {
        return (

              <Panel style={{backgroundColor:'#f3f3f3'}} className="panel panel-info">
              <Col md={6}>
                <FormGroup controlId="formValidationWarning4" >
                  <ControlLabel>Where to search</ControlLabel>
                  <FormControl name="wheretosearch" onChange={this.props.disableAnd} componentClass="select" placeholder="select">
                      <option value="phys_lineid">Within one line</option>
                      <option value="itemid">Within one text</option>
                </FormControl>
              </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup controlId="formValidationWarning4" >
                  <ControlLabel>Proximity Count</ControlLabel>
                  <FormControl name="pwrelevantnumbering" onChange={this.props.disableAnd} componentClass="select" placeholder="select">
                      <option value="pwrelevantnumbering">All elements</option>
                      <option value="pwrelevantnumbering2">Exclude word dividers (,) and philological notation</option>
                </FormControl>
              </FormGroup>
              </Col>
              </Panel>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/wordsearchscreens/Forms/WhereToSearch.jsx